import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import dayjs from 'dayjs'
import VueBus from '@/tool/event-bus.js'// 插件 事件总线
// 引入防止重复点击指令
import preventReClick from '@/utils/noDbClick'
Vue.use(preventReClick)

Vue.prototype.dayjs = dayjs
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(Vuex)
Vue.use(VueBus)

const VUE_APP_VERSION = require('../package.json').version
const vers = window.localStorage.getItem('appVersion')
if (VUE_APP_VERSION != vers) {
  localStorage.clear()
  window.localStorage.setItem('appVersion', VUE_APP_VERSION)
  location.reload()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
